import { cn } from '@/lib/cn';

type Props = {
  className?: string;
  markClassName?: string;
  wordmarkClassName?: string;
  showWordmark?: boolean;
};

export function HexdiLogo({
  className,
  markClassName,
  wordmarkClassName,
  showWordmark = true,
}: Props) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <HexdiMark className={cn('h-7 w-auto text-accent-secondary', markClassName)} />
      {showWordmark && (
        <span
          className={cn(
            'font-display font-bold text-text-primary',
            wordmarkClassName,
          )}
          style={{ fontSize: '17px', letterSpacing: '-0.02em', lineHeight: 1 }}
        >
          HEXDI
        </span>
      )}
    </span>
  );
}

export function HexdiMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 68 50"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="currentColor"
        d="M45.0819672 21.4761312H23.0530804L28.7578132 15.7909315L23.7250233 10.7753739L9.49108652 24.9605735L9.50184925 24.9712994L9.49108652 24.9820253L34.5950176 50L24.0071724 49.9738931L0 25.0523153L23.8062115 0.273224044L45.0819672 21.4761312ZM44.347923 49.726776L23.2240437 28.5964115H45.1511007L39.2786746 34.4706405L44.2882001 39.4817041L58.6504035 25.1150913L58.6396906 25.104375L58.6504035 25.0936588L33.6123998 0.0479680632L44.0798865 0L68.0327869 25.008098L44.347923 49.726776Z"
      />
    </svg>
  );
}
